import { selectGridPanelMaximized } from 'features/layout/features/content/contentSlice';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { useAppSelector } from 'store/hooks';
import { selectAdditionalControlsDisabled } from 'features/layout/selectors';
import { usePiPWindow } from 'components/PiP/PiPProvider';
import { readPipOuterWidth } from 'components/PiP/readPipOuterWidth';
import { useSystemSession } from 'hooks/useSystemSession';

export const useGridPanelDragHandle = () => {
  const { isMobile } = useBreakpoints();
  const gridPanelMaximized = useAppSelector(selectGridPanelMaximized);
  const additionalControlsDisabled = useAppSelector(selectAdditionalControlsDisabled);
  const isSystemSession = useSystemSession();

  const { pipWindow } = usePiPWindow();

  if (isSystemSession) {
    return false;
  }

  const pipOuterWidth = readPipOuterWidth(pipWindow);

  if (pipOuterWidth !== null && pipOuterWidth < 500) {
    return false;
  }

  const maximizeGridPanel = gridPanelMaximized || isMobile;

  return !maximizeGridPanel && !additionalControlsDisabled;
};
